var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { buildNameAndTypeProps, NameAndType } from './name-and-type';
import { buildStatusProps, Status } from './status';
import { Audience, buildAudienceProps } from './audience';
import { buildOpenRateProps, OpenRate } from './open-rate';
import { buildSalesProps, Sales } from './sales';
import { DateTime } from './date-time';
import { ActionsDropdown } from './actions';
import { sortByCreatedDate, sortByOpenRate } from '../../sort/sort-functions';
import { Expander } from './expander';
import { ACTIONS_COLUMN_ID, AUDIENCE_COLUMN_ID, DATE_TIME_COLUMN_ID, EXPANDER_COLUMN_ID, OPEN_RATE_COLUMN_ID, SALES_COLUMN_ID, } from './constants';
import { buildCreatedByProps, CreatedBy } from './created-by';
import styles from './styles.module.scss';
import { isShopSessionView } from '../../../../../../infra/session';
import { t } from '../../../../../../infra/i18n';
// Function to create columns with translated headers at runtime
var createBaseColumns = function () { return [
    {
        id: 'createdBy',
        header: function () { return _jsx("div", { className: styles['created-by-header'], children: t('engage:columns.by') }); },
        accessorKey: 'createdBy',
        cell: function (cellContext) {
            return _jsx(CreatedBy, __assign({}, buildCreatedByProps(cellContext.row.original)));
        },
        size: 60,
        minSize: 44,
        maxSize: 60,
    },
    {
        id: 'nameAndType',
        header: t('engage:columns.campaign'),
        accessorKey: 'displayName',
        cell: function (cellContext) {
            return _jsx(NameAndType, __assign({}, buildNameAndTypeProps(cellContext.row.original)));
        },
        size: 1,
        minSize: 180,
        meta: {
            isFlex: true,
        },
        sortingFn: 'text',
    },
    {
        id: 'status',
        header: t('engage:columns.status'),
        accessorKey: 'status',
        cell: function (cellContext) {
            return _jsx(Status, __assign({}, buildStatusProps(cellContext.row.original)));
        },
        size: 115,
        minSize: 85,
    },
    {
        id: AUDIENCE_COLUMN_ID,
        header: t('engage:columns.audience'),
        accessorKey: 'customerGroups',
        cell: function (cellContext) {
            return _jsx(Audience, __assign({}, buildAudienceProps(cellContext.row.original)));
        },
        size: 200,
        minSize: 200,
    },
    {
        id: OPEN_RATE_COLUMN_ID,
        header: t('engage:columns.open'),
        accessorKey: 'totalUniqueOpenRateCounter',
        cell: function (cellContext) {
            return _jsx(OpenRate, __assign({}, buildOpenRateProps(cellContext.row.original)));
        },
        size: 115,
        minSize: 85,
        sortingFn: sortByOpenRate,
    },
    {
        id: SALES_COLUMN_ID,
        header: t('engage:columns.sales'),
        accessorKey: 'revenue',
        cell: function (cellContext) {
            return _jsx(Sales, __assign({}, buildSalesProps(cellContext.row.original)));
        },
        size: 115,
        minSize: 115,
        sortingFn: 'basic',
    },
    {
        id: DATE_TIME_COLUMN_ID,
        accessorKey: 'createdAt',
        header: t('engage:columns.sent_date'),
        cell: function (cellContext) {
            return _jsx(DateTime, { campaign: cellContext.row.original });
        },
        size: 280,
        minSize: 150,
        sortingFn: sortByCreatedDate,
    },
    {
        id: ACTIONS_COLUMN_ID,
        accessorKey: 'id',
        header: '',
        cell: function (cellContext) {
            return _jsx(ActionsDropdown, { campaign: cellContext.row.original });
        },
        size: 34,
    },
    {
        id: EXPANDER_COLUMN_ID,
        accessorKey: 'id',
        header: '',
        cell: function (cellContext) { return _jsx(Expander, { isExpanded: cellContext.row.getIsExpanded() }); },
        size: 15,
    },
]; };
export var getColumnsForSession = function (session) {
    var isShopUser = isShopSessionView(session === null || session === void 0 ? void 0 : session.view);
    var baseColumns = createBaseColumns(); // ✅ t() called at runtime
    return baseColumns.filter(function (column) {
        if (column.id === 'createdBy') {
            return isShopUser;
        }
        return true;
    });
};
